import styled from "styled-components";
import {IDetailProperty} from "../../interfaces/IDetailProperty";

import {getTheme} from "../../shared/themeUtils";

const DetailPropertiesContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 20px 0;

    .img-contain {
        width: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
    }

    @media (max-width: ${getTheme("breakpoints.1")}) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
`;

const Image = styled.img`
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: ${getTheme("breakpoints.1")}) {
        max-width: 100%;
        width: 100%;
        border-radius: 8px;
    }
`;

const TextContainer = styled.div`
    padding: 0 ${getTheme("space.3")};
    @media (max-width: ${getTheme("breakpoints.1")}) {
        padding: 0;
        margin-top: ${getTheme("space.2")};
    }
`;

const Title = styled.h3`
    margin: 10px 0;
    font-size: ${getTheme("fontSizes.large")};
`;

const Description = styled.p`
    font-size: 0.9rem;
`;


type DetailPropertiesProps = {
  properties: IDetailProperty[];
};


const DetailProperties = (props: DetailPropertiesProps) => {
  return (
    <>
      {props.properties.map((property, index) => (
        <DetailPropertiesContainer key={index}>
          <div className="img-contain">
            <Image src={property.img}
                   alt={property.title}
                   style={{minWidth: "120px"}}
            />
          </div>
          <TextContainer>
            <Title>{property.title}</Title>
            <Description>{property.description}</Description>
          </TextContainer>
        </DetailPropertiesContainer>
      ))}
    </>
  );
};

export default DetailProperties;
